import React, { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';
import { sameId } from './gameHelpers';

const WaitingRoom = () => {
  const { game, players, currentPlayerId, startGame, removePlayer } = useContext(
    GlobalContext
  );

  const isOwner = sameId(game?.owner, currentPlayerId);
  const canStart = players.length >= 2;

  return (
    <div id="tm__waitingForPlayers" className="tm2">
      <div className="box">
        <h4 style={{ margin: '0 0' }}>Tell other players to visit:</h4>
        <div className="url">crds.app</div>
        <h4 style={{ margin: '0 0' }}>and use game code:</h4>
        <div id="shareGameCode">{game?.code}</div>
      </div>

      <div className="box">
        <h3 style={{ margin: '0 0' }}>Players Ready:</h3>
        <ul id="waitingPlayerList">
          {players.length > 0 ? (
            players.map((player, index) => {
              const playerIsOwner = sameId(player.id, game?.owner);
              const isMe = sameId(player.id, currentPlayerId);
              return (
                <li key={player.id || index} className="player-row">
                  <span>
                    {playerIsOwner && (
                      <span className="player-host" title="Host">
                        ♛{' '}
                      </span>
                    )}
                    {player.name}
                    {isMe && <span className="player-you"> (you)</span>}
                  </span>
                  {isOwner && !playerIsOwner && (
                    <button
                      type="button"
                      className="player-remove"
                      title={`Remove ${player.name}`}
                      onClick={() => removePlayer(player.id)}
                    >
                      ✕
                    </button>
                  )}
                </li>
              );
            })
          ) : (
            <li style={{ backgroundColor: 'transparent', color: '#fff' }}>
              <i className="fas fa-circle-notch fa-spin"></i>
            </li>
          )}
        </ul>
      </div>

      {game?.error && (
        <p className="error" role="alert">
          {game.error}
        </p>
      )}

      {isOwner ? (
        canStart ? (
          <button id="button__startGame" className="btn btn-gold" onClick={startGame}>
            Start Game
          </button>
        ) : (
          <h3>
            <i className="fas fa-circle-notch fa-spin"></i> Waiting for at least 2
            players…
          </h3>
        )
      ) : (
        <h3>
          <i className="fas fa-circle-notch fa-spin"></i> Waiting for the host to
          start the game…
        </h3>
      )}
    </div>
  );
};

export default WaitingRoom;
